import AllGiftCards from "./all-giftcards/index";

export default AllGiftCards;
